import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.purchaseOrders.PurchaseOrderContainer.';
  public static readonly purchaseOrderTitle = `${Id.prefix}purchaseOrderTitle`;
  public static readonly purchaseOrderSaved = `${Id.prefix}purchaseOrderSaved`;
}

export class LangPurchaseOrderContainer {
  private constructor() {}
  public static purchaseOrderTitle(params: { purchaseOrderNumber: string | number; title: string }): string {
    return interpolate(Id.purchaseOrderTitle, params);
  }
  public static purchaseOrderSaved(): string {
    return interpolate(Id.purchaseOrderSaved);
  }
}

export class PurchaseOrderContainerModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.purchaseOrderTitle,
      '#{{purchaseOrderNumber}} - {{title}}',
      'Title for purchase order, e.g. "#12345 - Office Supplies"'
    );
    register.add(
      Id.purchaseOrderSaved,
      "{{glossary 'purchase-order'}} saved",
      'Toast message for successfully saved purchase order'
    );
  }
}
